var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('ListPanel',{attrs:{"recipient-id":_vm.owner.data.id,"recipient-type":_vm.owner.data.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }